import { computed } from "vue";
import { useI18n } from "vue-i18n";
import useRegion from "./useRegion";

export type CarouselTestimonial = {
	mainText: string;
	fullName: string;
	position: string;
	companyName: string;
	photoUrl: string;
};

export default function useCarouselTestimonials() {
	const { locale, tm, rt } = useI18n({
		useScope: "global",
	});

	const testimonials = computed(() => {
		let regionCode = "HU";
		try {
			regionCode = useRegion.getCurrentRegion().code;
		} catch {
			regionCode = "HU";
		}

		let key: string | null = null;
		if (regionCode === "HU") {
			key = "carouselDataHu";
		} else if (regionCode === "RO") {
			key = locale.value === "hu" ? "carouselDataRo" : "carouselData";
		}

		if (!key) return [];

		const raw = tm(key);
		if (!Array.isArray(raw)) return [];

		return raw.map(
			(item: Record<string, unknown>): CarouselTestimonial => ({
				mainText: rt(item.mainText as string),
				fullName: rt(item.fullName as string),
				position: rt(item.position as string),
				companyName: rt(item.companyName as string),
				photoUrl: rt(item.photoUrl as string),
			})
		);
	});

	return {
		testimonials,
	};
}
